import $ from 'jquery';

/**
 * Configures defaults for AJAX requests.
 */
$.ajaxSetup({
    accepts: { json: 'application/json' },
    cache: false,
    dataType: 'json'
});


// WEBPACK FOOTER //
// ./init/jquery.js